import React from 'react'

import { useTranslation } from 'react-i18next'

import { Button } from '@/Atomic/Molecules/Button'
import { MenuItemProps } from '@/Atomic/Molecules/MenuItem'
import DropdownMenu from '@/Atomic/Organisms/DropdownMenu'

interface HeaderActionsProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  menuItems?: MenuItemProps[]
  extraAction?: React.ReactNode
}

export const HeaderActions: React.FC<HeaderActionsProps> = ({
  onClick,
  menuItems,
  extraAction,
}) => {
  const { t } = useTranslation()

  return (
    <div className="actions">
      {extraAction}
      <Button
        icon="edit"
        variant="outlined"
        size="sm"
        onClick={onClick}
        aria-label={t('common.edit')}
      >
        <span className="edit-label">{t('common.edit')}</span>
      </Button>
      {menuItems && <DropdownMenu menuItems={menuItems} />}
    </div>
  )
}
